import FormOTPAndPIN from "@components/inputs/FormOTPAndPIN";
import { usePostLoginCheck } from "@components/utils/Auth/hooks";
import { RegisterCallbackProps } from "@components/utils/Auth/types";
import { SEON_FEATURE } from "@configs/seon";
import { OnboardMode } from "@constants";
import { useOnboardingPhone } from "@hooks/useOnboardingPhone";
import { useSeonSession } from "@hooks/useSeonSession";

interface RegisterPPProps extends RegisterCallbackProps {}

const RegisterPP = ({
  onLoginSuccess,
  onPostLoginCheckFailed,
  onRegisterSuccess,
  onPostLoginCheckPassed,
  deferUpdateToken,
}: RegisterPPProps) => {
  const { phone } = useOnboardingPhone();
  const postLoginCheck = usePostLoginCheck({
    onLoginSuccess,
    onPostLoginCheckPassed,
    onPostLoginCheckFailed,
    redirectHome: false,
  });
  useSeonSession(SEON_FEATURE.REGISTER, {
    autoInit: true,
  });

  return (
    <FormOTPAndPIN
      phone={phone}
      mode={OnboardMode.REGISTER}
      onLoginSuccess={postLoginCheck}
      onRegisterSuccess={onRegisterSuccess}
      otpMode="register"
      deferUpdateToken={deferUpdateToken}
    />
  );
};

export default RegisterPP;
